import { toJS } from 'mobx'

import type { RealtyImage } from 'shared/api/kyrgyzstan/search'
import type { DynamicFieldValue } from 'shared/api/kyrgyzstan/search/model'

export interface KyrgyzstanGalleryRouteState {
  gallery?: {
    realtyId: string
    title: string
    images: RealtyImage[]
  }
}

export interface KyrgyzstanMapRouteState {
  map?: {
    realtyId: string
    title: string
    address: string
    latitude: number
    longitude: number
  }
}

export interface KyrgyzstanAmenitiesRouteState {
  amenities?: {
    realtyId: string
    dynamicFields: DynamicFieldValue
  }
}

interface KyrgyzstanGalleryRouteStateSource {
  id: string
  title: string
  images: RealtyImage[]
}

interface KyrgyzstanMapRouteStateSource {
  id: string
  title: string
  address: string
  latitude: number
  longitude: number
}

interface KyrgyzstanAmenitiesRouteStateSource {
  id: string
  dynamicFields: DynamicFieldValue
}

export const getKyrgyzstanGalleryRouteState = (
  realty: KyrgyzstanGalleryRouteStateSource,
): KyrgyzstanGalleryRouteState => ({
  gallery: {
    realtyId: realty.id,
    title: realty.title,
    images: realty.images.map(({ id, order, image_url }) => ({
      id,
      order,
      image_url,
    })),
  },
})

export const getKyrgyzstanMapRouteState = (
  realty: KyrgyzstanMapRouteStateSource,
): KyrgyzstanMapRouteState => ({
  map: {
    realtyId: realty.id,
    title: realty.title,
    address: realty.address,
    latitude: realty.latitude,
    longitude: realty.longitude,
  },
})

export const getKyrgyzstanAmenitiesRouteState = ({
  id,
  dynamicFields,
}: KyrgyzstanAmenitiesRouteStateSource): KyrgyzstanAmenitiesRouteState => ({
  amenities: {
    realtyId: id,
    dynamicFields: structuredClone(toJS(dynamicFields)),
  },
})
